'use strict';

import angular from 'angular';

import modalDirective from 'brg/rest/buttons/modal';
import resolveUsers from 'utils/resolve/users';

import addTemplate from './add.html';

const MODULE_NAME = 'daupler.entities.admin.designatedUser';

var app = angular.module(MODULE_NAME, [
	'ui.mask',
	'brg.components.inputs',
]);

app.directive('addDesignatedUser', modalDirective({
	template: addTemplate,
	resolve: {
		users: resolveUsers,
	},
	controller: addController,
}));

export default MODULE_NAME;


function addController($scope) {
	'ngInject';

	$scope.handleSuccess = function(result) {
		if ($scope.$context.doNotReload) {
			$scope.$close(result);
		} else {
			$scope.$reload();
		}
	}

	$scope.updatePhoneNumber = function(item, modal, label) {
		if ($scope.$context.userPhoneNumber) {
			$scope.designatedUser.phone_number = item.phone_number;
		}
	}
}
